/*
  MME LOAD MORE - Sept 13 2026
  Runs Ajaxinate (assets/ajaxinate.min.js) in CLICK mode on collection
  and search grids. Replaces the old infinite scroll.

  How it works: the Load More button inside #MmeLoadMore links to the
  next page. On click, Ajaxinate fetches that page, appends its
  #MmeLoadMoreLoop products under the ones already showing, and swaps
  in that page's #MmeLoadMore (new count + next button, or "Showing all").

  Re-hooks itself after a filter change, because Impulse re-renders the
  grid by AJAX and fires collection:reloaded when it is done.

  To go back to plain numbered pages: remove the script tag in
  sections/main-collection.liquid and delete the #MmeLoadMore div in
  snippets/collection-grid.liquid. The numbered pagination underneath
  already works on its own.
*/
(function () {
  function mmeInitLoadMore() {
    if (typeof Ajaxinate !== 'function') return;
    if (!document.getElementById('MmeLoadMoreLoop')) return;

    new Ajaxinate({
      container: '#MmeLoadMoreLoop',
      pagination: '#MmeLoadMore',
      method: 'click',
      loadingText: 'Loading...',
      callback: function () {
        // Wake up the newly added cards: scroll-in animation, quick shop, reviews.
        if (window.theme && typeof theme.reinitProductGridItem === 'function') {
          theme.reinitProductGridItem();
        }
      }
    });
  }

  if (document.readyState !== 'loading') {
    mmeInitLoadMore();
  } else {
    document.addEventListener('DOMContentLoaded', mmeInitLoadMore);
  }

  // Impulse fires this after a filter click re-renders the grid.
  document.addEventListener('collection:reloaded', mmeInitLoadMore);
})();
